import { defineMessages } from 'react-intl';

export default defineMessages({
    repaymentOptionHeading: {
        id: '_.interest_only.radio_buttons.heading',
        defaultMessage: 'How would you like to repay your loan?'
    },
    monthlyRepaymentsDuration: {
        id: '_.interest_only.radio_buttons.monthly_repayments_option',
        defaultMessage: '{months} monthly repayments'
    },
    repaymentAmount: {
        id: '_.interest_only.radio_buttons.repayment_amount',
        defaultMessage: '(min. {amount} per month)'
    },
    interestOnlyPeriodLabel: {
        id: '_.interest_only.repayment_breakdown.interest_only_period',
        defaultMessage: 'Interest-only period'
    },
    interestOnlyPeriodDuration: {
        id: '_.interest_only.repayment_breakdown.interest_only_period_duration',
        defaultMessage: '{duration} months'
    },
    monthLabel: {
        id: '_.interest_only.repayment_breakdown.month_label',
        defaultMessage: 'Month {monthNumber}'
    },
    hideDetailsLabel: {
        id: '_.interest_only.repayment_breakdown.hide_details',
        defaultMessage: 'hide details'
    },
    showDetailsLabel: {
        id: '_.interest_only.repayment_breakdown.show_details',
        defaultMessage: 'show details'
    }
});
